//make a simple react component
import React from "react";
import { Inputs } from "../types/chatbot.types";

interface StarRatingProps {
	submitHandler: (selected: any) => void;
	item: any;
	idx: number;
	values: Inputs;
	rate: number;
	setRate: (rate: number) => void;
	setInputs: (values: Inputs) => void;
}

const StarRating: React.FC<StarRatingProps> = ({
	values,
	submitHandler,
	item,
	idx,
	setInputs,
	setRate,
	rate,
}) => {
	return (
		<div>
			<div className="formrating" key={idx}>
				<p>{item.text}</p>
				{item.columns.map((column: any, index: number) => {
					return (
						<div
							onClick={() => {
								setRate(column.items[0].selectAction.data.rate);
								let temp = {
									...values,
									rate: column.items[0].selectAction.data.rate,
								};
								setInputs(temp);
							}}
							className={
								// eslint-disable-next-line eqeqeq
								rate == index + 1
									? index === 0
										? "formStarfirstfilled"
										: index === item.columns.length - 1
										? "formStarlastfilled"
										: "formStarfilled"
									: index === 0
									? "formStarfirst"
									: index === item.columns.length - 1
									? "formStarlast"
									: "formStar"
							}
							key={index}
						>
							{column.items.map((item: any, idx: number) => {
								return (
									<div key={idx}>
										<div className="ratenumber">
											{item.selectAction.data.rate}
										</div>
									</div>
								);
							})}
						</div>
					);
				})}
			</div>

			<button onClick={(e) => submitHandler(e)} className="endChatButton">
				<p>End chat</p>
			</button>
		</div>
	);
};

export default StarRating;
